import { useState, useEffect } from 'react';
import { db } from '@/lib/firebase/config';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { IconDisplay } from '@/components/ui/icon-picker';
import { useLanguage } from '@/contexts/LanguageContext';

interface Statistic {
  id: string;
  number: string;
  label: string | { ar: string; en: string };
  icon: string;
  order: number;
}

export function LandingStatistics() {
  const [statistics, setStatistics] = useState<Statistic[]>([]);
  const [loading, setLoading] = useState(true);
  const { t, language } = useLanguage();

  useEffect(() => {
    fetchStatistics();
  }, []);

  const fetchStatistics = async () => {
    try {
      const statsQuery = query(
        collection(db, 'landing_statistics'),
        orderBy('order', 'asc')
      );
      const querySnapshot = await getDocs(statsQuery);

      const statsData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      })) as Statistic[];

      setStatistics(statsData);
    } catch (err) {
      console.error('Error fetching statistics:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">{t('landing.common.loading')}</div>
        </div>
      </section>
    );
  }

  return (
    <section className="pt-0 pb-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 text-center">
          {statistics.map((stat) => {
            const label = typeof stat.label === 'string' ? stat.label : (stat.label[language] || stat.label.ar);
            
            return (
            <div key={stat.id} className="bg-[#8fe566] p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
              <IconDisplay iconName={stat.icon} className="w-12 h-12 text-white mx-auto mb-4" />
              <div className="text-4xl font-bold text-[#004250] mb-2">{stat.number}</div>
              <div className="text-white text-2xl">{label}</div>
            </div>
          )}
          )}
        </div>
      </div>
    </section>
  );
}

